import { ESPOT_CARD_TYPE, ESPOT_LIST_TYPE, ESPOT_TYPE } from '@/constants/espot';

export const isEspotHtml = (espot) => espot?.type === ESPOT_TYPE.HTML && espot?.htmlContent;

export const isEspotImageInfoCardList = (espot) =>
	espot?.type === ESPOT_TYPE.LIST &&
	espot?.listType === ESPOT_LIST_TYPE.CARD &&
	(!espot?.cardType || espot?.cardType === ESPOT_CARD_TYPE.CARD_1);

export const isEspotInfoCardList = (espot) =>
	espot?.type === ESPOT_TYPE.LIST && espot?.listType === ESPOT_LIST_TYPE.CARD && espot?.cardType === ESPOT_CARD_TYPE.CARD_2;

export const isEspotDuoList = (espot) => espot?.type === ESPOT_TYPE.LIST && espot?.listType === ESPOT_LIST_TYPE.DUO_CARD;

export const isEspotListSample = (espot) => espot?.type === ESPOT_TYPE.LIST && espot?.listType === ESPOT_LIST_TYPE.SAMPLE;

export const isEspotVideo = (espot) => espot?.type === ESPOT_TYPE.VIDEO;

export const isEspotDisplayed = (espot, isMobileDevice) => {
	return espot ? !isMobileDevice || espot.isDisplayMobile : false;
};

export const formatVideoPresentationData = (data) => {
	const { contentTitle, desc, label, url, img, idYoutube, htmlContent, isNofollow } = data;

	return {
		text: {
			title: contentTitle,
			desc,
		},
		link: {
			label,
			url,
		},
		img,
		video: {
			idYoutube,
		},
		htmlContent,
		isNofollow,
	};
};

export const formatImageInfoCardListData = (data) => {
	const { img, backgroundColor: color, contentTitle, desc, alt } = data;
	return {
		img,
		color,
		contentTitle,
		desc,
		cta: formatCtaData(data),
		alt,
	};
};

export const formatInfoCardListData = (data) => {
	if (!data) {
		return {};
	}

	const { title, desc } = data;
	return {
		contentTitle: title,
		desc,
		cta: formatCtaData(data),
	};
};

export const formatCtaData = ({
	url,
	label,
	btnTextColor,
	btnHoverTextColor,
	btnBackgroundColor,
	btnHoverBackgroundColor,
	isNofollow,
}) => ({
	url: url,
	text: {
		label: label,
		color: btnTextColor,
		hoverColor: btnHoverTextColor,
	},
	background: {
		color: btnBackgroundColor,
		hoverColor: btnHoverBackgroundColor,
	},
	isNofollow,
});
